const types = require('constants/actionTypes');

const opened = ({ query = '' }) => ({
    type: types.GLOSSARY_OPENED,
    payload: { query },
});

module.exports = opened;
